module.exports = __webpack_public_path__ + "media/img/frontend_application/footericon/pinterest-ce9696795fca2ec9557f4342920cd2d2.svg";